import axios from 'axios'
import { parseParams } from '../helper/utility'
import { axiosGet } from '../Redux/axiosHelper'
import {
  CategoryType,
  EventAnalyticsParams,
  PaginatedParams,
  RequestParms,
  ReviewsStatsTypes,
} from '../types/globalTypes'
import { BASE_URL } from './global'
import { useQuery } from '@tanstack/react-query'
import {
  PaginatedCommonEventResp,
  PaginatedEventsResp,
} from 'types/event/events'
import { EventAttendeesResp } from 'types/event/eventAttendance'

export const getEvents = async (params: any) => {
  const pars = parseParams(params)
  const response = await axiosGet(`v1/organization-events?${pars}`)
  return response.data
}

export const getEventFaqs = async (eventId: string) => {
  const response = await axiosGet(`v1/event-questions/event/${eventId}`)
  return response.data
}
export const getFamilyEvents = async (familyId: any, params: RequestParms) => {
  const response = await axiosGet(`v1/families/${familyId}/events`, params)
  return response.data
}
export const getEventById = async (eventId: string) => {
  const response = await axiosGet(`v1/organization-events/${eventId}`)
  return response.data
}
export const getGuardianEvents = async (
  guardianId: string,
  params: RequestParms,
) => {
  const response = await axiosGet(`v1/guardians/${guardianId}/events`, params)
  return response.data
}
export const getEventAnalytics = async (
  orgId: string,
  params?: EventAnalyticsParams,
) => {
  const response = await axiosGet(
    `v1/organization-events/${orgId}/analytics`,
    params,
  )
  return response.data
}
export const getAttendieByDate = async (eventId: string, date: any) => {
  const response = await axiosGet(
    `v1/manage-events/${eventId}/participants/day?date=${date}`,
  )
  return response.data
}
export const getEventCheckInList = async (eventId: string) => {
  const response = await axiosGet(`v1/check/list/event/${eventId}`)
  return response.data
}
export const getEventGroups = async (eventId: string) => {
  const response = await axiosGet(`v1/manage-events/${eventId}`)
  return response.data
}
export const getEventAttendeeTickets = async (
  eventId: string,
  memberId: string,
) => {
  const response = await axiosGet(
    `v1/booking/get-participant-tickets/${eventId}`,
    { memberId },
  )
  return response.data
}
export const cancelRegistration = async (body: any) => {
  const response = await axios.post(
    `${BASE_URL}v1/booking/cancel-user-all-booking`,
    body,
  )

  return response.data
}
export const deleteTicket = async (body: any) => {
  const response = await axios.post(
    `${BASE_URL}v1/booking/cancel-booking`,
    body,
  )

  return response.data
}

const getEventReviewsStats = async (params: { eventId: string }) => {
  const response = await axiosGet(`v1/reviews/stats`, params)
  return response.data
}

export const useGetEventReviewsStats = (params: { eventId: string }) => {
  const eventReviewsStat = useQuery<ReviewsStatsTypes>(
    ['event-review-stats'],
    () => getEventReviewsStats(params),
    { enabled: false },
  )
  return eventReviewsStat
}

const getEventReviewsList = async (params: { eventId: string }) => {
  const response = await axiosGet(`v1/reviews`, params)
  return response.data
}

export const useGetEventReviewsList = (params: { eventId: string }) => {
  const eventReviewsList = useQuery<any>(
    ['event-review-list'],
    () => getEventReviewsList(params),
    { enabled: false },
  )
  return eventReviewsList
}

const getEventForKids = async (
  kidId: string,
  params: { page: number; limit: number },
) => {
  const response = await axiosGet(`v1/kids/${kidId}/events`, params)
  return response.data
}

export const useGetEventForKids = (
  kidId: string,
  params: { page: number; limit: number },
) => {
  const kidEvents = useQuery<PaginatedEventsResp>(
    ['event-review-list'],
    () => getEventForKids(kidId, params),
    { enabled: false },
  )
  return kidEvents
}

export const getEventCategories = async () => {
  const response = await axiosGet(`v1/lists/event-categories`)
  return response.data
}
export const useGetEventCategories = () => {
  const eventCategoriesList = useQuery<CategoryType[]>(
    ['event-categories-list'],
    getEventCategories,
  )
  return eventCategoriesList
}

export const getEventParticipants = async (id: string) => {
  const response = await axiosGet(`v1/manage-events/${id}/participants`)
  return response.data
}

export const useGetEventParticipants = (id: string) => {
  const eventParticipants = useQuery<EventAttendeesResp>(
    ['event-participants-list'],
    () => getEventParticipants(id),
    { enabled: false },
  )
  return eventParticipants
}
const getCommonEventListing = async (params: PaginatedParams) => {
  const pars = parseParams(params)
  const response = await axiosGet(
    `v1/common-events/organization-events?${pars}`,
  )
  return response.data
}
export const useGetCommonEventListing = (params: PaginatedParams) => {
  const commonEventListing = useQuery<PaginatedCommonEventResp>(
    ['common-event-listing'],
    () => getCommonEventListing(params),
    { enabled: false },
  )
  return commonEventListing
}
